export const USER = 'user';

export const setStoredAuthState = payload => {
  localStorage.setItem(USER, JSON.stringify(payload));
};

export const removeStoredAuthState = () => {
  localStorage.removeItem(USER);
};

export const getStoredAuthState = () => {
  try {
    const user = JSON.parse(localStorage.getItem(USER));

    return { user };
  } catch (error) {
    removeStoredAuthState();

    return {};
  }
};
